import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';

export type Admin = {
  admin_account: string;
  password: string;
};

export type User = {
  user_account: string;
  password: string;
};

export type Duplicate = {
  type: string;
  admin_account?: string;
  admin_email?: string;
  admin_phone?: string;
  user_account?: string;
  user_email?: string;
  user_phone?: string;
};

export type FindAccount = {
  admin_email?: string;
  admin_phone?: string;
  admin_name?: string;
  user_email?: string;
  user_name?: string;
  user_phone?: string;
  type?: string;
  auth_type?: string;
};

const $http = new APIManager();

const Api = {
  /**
   * [POST] Auth Check
   * --
   */
  authCheck: async () => {
    try {
      const res = await $http.post(APIConstant.AUTH_CHECK);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Admin Login
   * --
   */
  adminLogin: async (body: Admin) => {
    try {
      const res = await $http.post(APIConstant.ADMIN_LOGIN, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] User Login
   * --
   */
  userLogin: async (body: User) => {
    try {
      const res = await $http.post(APIConstant.USER_LOGIN, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Duplicate Check
   * --
   */
  duplicateCheck: async (body: Duplicate) => {
    try {
      const res = await $http.post(APIConstant.DUPLICATE_CHECK, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Social Login
   * --
   */
  socialLogin: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.SOCIAL_LOGIN, params);
      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] VERIFY PREV
   * --
   */
  verifyPrev: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.VERIFY_PREV, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] VERIFY
   * --
   */
  verify: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.VERIFY, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Find Account
   * --
   */
  findAccount: async (body: FindAccount) => {
    try {
      const res = await $http.post(APIConstant.FIND_ACCOUNT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
